import { ItemCategoriesMultiAutoComplete } from "@/features/ui/multiAutoComplete/itemCategory/itemCategory-multiAutoComplete";
import { FormTypeProps, FormValues } from "./CustomFilterForm";

import { AbstractItemsMultiAutoComplete } from "@/features/ui/multiAutoComplete/abstractItem/abstractItem-multiAutoComplete";
import { EquipmentsMultiAutoComplete } from "@/features/ui/multiAutoComplete/equipment/equipment-multiAutoComplete";
import { ItemsMultiAutoComplete } from "@/features/ui/multiAutoComplete/item/item-multiAutoComplete";
import { ItemTypesMultiAutoComplete } from "@/features/ui/multiAutoComplete/itemType/itemType-multiAutoComplete";
import { LocationsMultiAutoComplete } from "@/features/ui/multiAutoComplete/location/location-multiAutoComplete";
import { MoldsMultiAutoComplete } from "@/features/ui/multiAutoComplete/mold/mold-multiAutoComplete";
import { OperationsMultiAutoComplete } from "@/features/ui/multiAutoComplete/operation/operation-multiAutoComplete";
import { RoutingsMultiAutoComplete } from "@/features/ui/multiAutoComplete/routing/routing-multiAutoComplete";
import { RoutingTypesMultiAutoComplete } from "@/features/ui/multiAutoComplete/routingType/routingType-multiAutoComplete";
import { SitesMultiAutoComplete } from "@/features/ui/multiAutoComplete/site/site-multiAutoComplete";
import { UsersMultiAutoComplete } from "@/features/ui/multiAutoComplete/user/user-multiAutoComplete";
import styled from "@emotion/styled";
import { MultiSelect } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

interface SampleProps {
  formValue: UseFormReturnType<FormTypeProps>;
  multiField: string;
}

const toArray = (value?: string[]): string[] => (Array.isArray(value) ? value : []);

export const MultiField: React.FC<SampleProps> = ({ formValue, multiField }) => {
  const multiFieldName = multiField as keyof FormValues;

  const handleChange = (field: keyof FormValues, nextValues: string[]) => {
    const uniqueValues = Array.from(new Set(nextValues.filter(Boolean)));
    formValue.setFieldValue(field, uniqueValues);
  };

  const renderComponent = (fieldName: keyof FormTypeProps) => {
    const value = toArray(formValue.values[fieldName as keyof FormValues]);
    const error = formValue.errors[fieldName as keyof FormValues];

    const commonProps = {
      value,
      error,
      onChange: (selected: string[]) => handleChange(fieldName as keyof FormValues, selected),
    };

    switch (fieldName) {
      // 다른 필드에 대한 컴포넌트를 조건부로 렌더링할 경우, 여기에 추가
      case "abstractItemCode":
        return <AbstractItemsMultiAutoComplete {...commonProps} />;
      case "equipmentCode":
        return <EquipmentsMultiAutoComplete {...commonProps} />;
      case "itemCode":
        return <ItemsMultiAutoComplete {...commonProps} />;
      case "itemCategoryName":
        return <ItemCategoriesMultiAutoComplete {...commonProps} />;
      case "locationCode":
      case "fromLocationCode":
      case "toLocationCode":
        return <LocationsMultiAutoComplete {...commonProps} />;
      case "moldCode":
        return <MoldsMultiAutoComplete {...commonProps} />;
      case "routingCode":
        return <RoutingsMultiAutoComplete {...commonProps} />;
      case "operationCode":
        return <OperationsMultiAutoComplete {...commonProps} />;
      case "siteCode":
        return <SitesMultiAutoComplete {...commonProps} />;
      case "userCode":
        return <UsersMultiAutoComplete {...commonProps} />;
      case "itemType":
        return <ItemTypesMultiAutoComplete {...commonProps} />;
      case "routingType":
        return <RoutingTypesMultiAutoComplete {...commonProps} />;
      default:
        return null;
    }
  };

  return renderComponent(multiFieldName);
};

export const FKMultiSelect = styled(MultiSelect)`
  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
`;

export const FKInfoLabel = styled.div`
  font-size: 12px;
  color: #666666;
  // padding-right: 8px;
  padding-left: 0.4rem;
  display: flex;
`;
